import "./modalSession.css";
import close from "../../assets/svgs/close.svg";
import { ButtonGeneric } from "../ButtonGeneric/buttonGeneric";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { useLocation } from "react-router-dom";
import { useSessionHandler } from "../../hooks/useSessionHandler";
interface ModalProps {
  titleModal?: string;
  titleDescription?: any;
  bodyModal?: any;
  buttonOne?: string;
  buttonTwo?: string;
  buttonThree?: string;
  buttonFour?: string;
  onLogout?: () => void;
  onClose?: () => void;
  onCloseX?: () => void;
  onConfirm?: () => void;
  className?: string;
  classNameAux?: string;
  setModalDisplay?: any;
  setLoading?: any;
}

export const Modal = ({
  titleModal,
  titleDescription,
  bodyModal,
  buttonOne,
  buttonTwo,
  buttonThree,
  buttonFour,
  onClose,
  onCloseX,
  onConfirm,
  onLogout,
  className,
  classNameAux,
  setModalDisplay,
  setLoading,
}: ModalProps) => {
  const [, setModalProduct] = useState<any>(null);
  const [, setModalDesc] = useState<any>(null);
  const [, setQuestionsTrue] = useState(false);

  const { sessionVerify } = useSelector(
    (state: RootState) => state.sessionInfo
  );

  const location = useLocation();

  useEffect(() => {
    if (location.state?.startAtStep === "questions") {
      setQuestionsTrue(true);
    }
  }, [location.state]);

  useSessionHandler({
    sessionVerify,
    setLoading,
    setModalDisplay,
    setModalProduct,
    setModalDesc,
  });

  return (
    <div className={`modalCorporateSession ${className}`}>
      <div className="modal">
        <div style={{ width: "100%" }}>
          <img
            style={{
              marginRight: 10,
              position: "absolute",
              right: 10,
              top: 20,
              cursor: "pointer",
            }}
            src={close}
            alt="icon close"
            width={18}
            height={18}
            role="button"
            onClick={onCloseX}
          />
          <div className="containerTitleModal">
            {titleModal && <h1 className="titleModal">{titleModal}</h1>}
          </div>
          <div className="containerDescription">
            {titleDescription}

            {bodyModal && (
              <span className="bodyModal" id="bodyModalStyle">
                {bodyModal}
              </span>
            )}

            <div className="buttonsEdit">
              {buttonOne && (
                <ButtonGeneric
                  style="buttonGenericCustom buttonGeneric buttonHover"
                  title={buttonOne}
                  colorTitle="#fff"
                  onClick={onConfirm}
                />
              )}
              {buttonTwo && (
                <ButtonGeneric
                  style="buttonGenericCustom"
                  title={buttonTwo}
                  colorTitle="#007BC0"
                  onClick={onClose}
                />
              )}
              {buttonThree && (
                <ButtonGeneric
                  style="buttonGenericCustom"
                  title={buttonThree}
                  colorTitle="#007BC0"
                  onClick={onLogout}
                />
              )}
              {buttonFour && (
                <ButtonGeneric
                  style={`buttonGenericCustom ${classNameAux}`}
                  title={buttonFour}
                  colorTitle="#007BC0"
                  onClick={onCloseX}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
